<template>
    <div>
        <card-header title="Section Outline" icon="fa-list" />

        <card-toolbar>
            <button @click="$openCard('new-section-component', {sectionId: section.id}, card)"><i class="far fa-file-plus"></i>New Component</button>
            <button @click="$openCard('edit-outline-item', {outlineId: props.outlineId, courseId: props.courseId}, card)"><i class="far fa-pencil"></i>Edit Section</button>
        </card-toolbar>

        <card-body>

            <card-list>
                <subheader-list-item title="Section Outline" icon="fa-list-alt" />

                <draggable v-model="section.components" handle=".drag-handle" @end="completeDrag" draggable=".t-card-list-item">
                    <transition-group>

                        <card-list-item
                            class="t-card-list-item"
                            :class="{'active': child && child.definition.component === 'new-component-editor' && child.props.componentId == c.component_id}"
                            v-for="c in section.components"
                            :key="c.id" @click="$openCard('new-component-editor', {componentId: c.component_id, outlineId: c.id}, card)"
                        >
                            <template #icon><i class="fa-fw far" :class="{
                                'fa-memo-pad': c.type === 'LESSON',
                                'fa-message-question': c.type === 'QUIZ',
                                'fa-location-check': c.type === 'CHECKPOINT',
                                'fa-photo-film-music': c.type === 'MEDIA',
                                'fa-clipboard': c.type === 'FORM',
                                'fa-poll-people': c.type === 'SURVEY',
                                'fa-rectangle-code': c.type === 'IFRAME'
                            }"></i></template>
                            <template #content>
                                <div class="columns">
                                    <div class="column is-10">
                                        <div class="tile-title">{{ c.title }}</div>
                                        <div class="meta mt-1"><i class="far fa-cube fa-fw mr-2"></i>{{ c.type | outlineType }}</div>

                                    </div>
                                    <div class="column has-text-right">
                                        <p class="control">
                                            <i class="fas fa-sort drag-handle"></i>
                                        </p>
                                    </div>
                                </div>
                            </template>
                            <template #details>
                                <div class="meta mb-3" v-if="c.description"><i class="far fa-align-left fa-fw mr-2"></i>{{ c.description }}</div>

                                <div class="mt-2">
                                    <toolbar class="toolbar">
                                        <b-tooltip label="Edit Component">
                                            <button class="icon-only" @click.stop="$openCard('new-component-editor', {componentId: c.component_id, outlineId: c.id}, card)"><i class="far fa-pencil"></i></button>
                                        </b-tooltip>
                                        <b-tooltip label="Delete Component">
                                            <button class="icon-only" @click.stop="deleteComponent(c)"><i class="far fa-trash-alt"></i></button>
                                        </b-tooltip>
                                    </toolbar>
                                </div>
                            </template>
                        </card-list-item>
                    </transition-group>
                </draggable>
            </card-list>
        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';
    import async from 'async';
    import draggable from "vuedraggable";
    import Toolbar from "../../TIER/components/Toolbar.vue";

    export default {
        components: {Toolbar, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                section: {components: []},
                components: [],
                confirmDelete: false,
                dirty: null,
                type: null,
                title: null,
                componentSelect: null
            };
        },
        methods: {
            loadSection: function (force) {
                async.series([
                    (cb) => {
                        this.$emit('loading', true);
                        http.get('sections/' + this.props.sectionId, {force}).then(response => {
                            this.section = response.data;
                            cb();
                        }).catch(cb);
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            deleteComponent: function (component) {
                if (window.confirm('Are you sure you want to delete this component? This is a permanent action.')) {
                    http.delete('sections/outline/' + component.id).then(response => {
                        this.section.components = this.section.components.filter(c => c.id !== component.id);
                    });
                }
            },

            completeDrag: function () {
                http.post('sections/order', this.section.components.map(i => i.id)).then(response => {

                });
            },
            reload() {
                this.loadSection(true);
            }
        },
        watch: {
            'props.sectionId': function () {
                this.dirty = null;
                this.loadSection();
            },
            'course': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this course? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadSection();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }
</style>
